import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    maxWidth: "90vw",
    maxHeight: "90vh",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
      maxWidth: "95vw",
    },
  },
}));

let paramsData = {};

const LicenseImageDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="license-image-dialog-title"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        id="license-image-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {t("licenseImage") || "License Image"}
        </Typography>
        <IconButton
          onClick={handleClose}
          sx={{
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {paramsData?.imageUrl ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              minHeight: "400px",
              backgroundColor: "#f5f5f5",
              borderRadius: 2,
              p: 2,
            }}
          >
            <img
              src={paramsData.imageUrl}
              alt={t("licenseImage") || "License Image"}
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <Typography color="text.secondary">
              {t("noImageAvailable") || "No license image available"}
            </Typography>
          </Box>
        )}
      </DialogContent>
    </BootstrapDialog>
  );
});

LicenseImageDialog.displayName = "LicenseImageDialog";

export default LicenseImageDialog;
